
import DefaultController from './../../controller';
import {createObjectFromDefault} from './../../functions';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        this.type = 'defs'; 

    }

}


let Blueprint = {
    type: Controller,
    properties: {  },
    children: [  ]
}

export default Blueprint;
export {Controller};